import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function ViewFile() {
  const { filename } = useParams();
  const token = localStorage.getItem('token');
  const fileUrl = `/api/secure-download/${filename}?token=${token}`;
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <div style={{ 
        padding: isMobile ? '8px' : '10px', 
        background: '#1976d2', 
        color: 'white', 
        display: 'flex', 
        flexDirection: isMobile ? 'column' : 'row',
        gap: isMobile ? '8px' : '0',
        justifyContent: 'space-between', 
        alignItems: isMobile ? 'stretch' : 'center'
      }}>
        <h3 style={{ margin: 0, fontSize: isMobile ? '16px' : '18px', wordBreak: 'break-word' }}>📄 {filename}</h3>
        <a 
          href={fileUrl} 
          download 
          style={{ 
            background: '#4caf50', 
            padding: '6px 12px', 
            color: 'white', 
            textDecoration: 'none', 
            borderRadius: 4,
            textAlign: 'center'
          }}
        >
          ⬇️ Download
        </a>
      </div>
      <iframe
        src={fileUrl}
        title="Secure File"
        style={{ flexGrow: 1, width: '100%', border: 'none' }}
      />
    </div>
  );
}
